import { CustomTableHeader } from '../../../../components/CustomTable';
import BolinhaTabelaStatus from '../../../../components/bolinhaTabelaStatus';

export const valoresExibidosOffCanvasSES: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorContato: '',
  separadorCEP: '',
  separadorObservacoes: '',

  //Específicos
  ses: 'Nome da SES',
  nome: 'Nome da SES',
  cnes: 'Número do CNES',
  nomeEmpresarial: 'Nome Empresarial',
  municipioIbge: 'Município',
  naturezaJuridica: 'Natureza Jurídica',
  dependencia: 'Dependência',
  regionalSaude: 'Nº Regional de Saúde',
  tipoEstabelecimento: 'Tipo Estabelecimento',
  subtipoEstabelecimento: 'Subtipo Estabelecimento',
  gestao: 'Gestão',
  telefone1: 'Telefone',
  telefone2: 'Telefone Secundário',
  email: 'Email',
  site: 'Site',
  cep: 'CEP',
  municipio: 'Município',
  uf: 'UF',
  endereco: 'Endereço',
  bairro: 'Bairro',
  logradouro: 'Logradouro',
  numeroImovel: 'Nº Imóvel',
  complemento: 'Complemento',
};

export const fieldObjectSes = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'naturezaJuridica.naturezaJuridica',
  'municipioIbge.municipio',
  'municipioIbge.ufSigla',
];

export type SesTableRow = {
  id: string | number;
  nome: string;
  ufSigla: string;
  cnes: string;
  nomeEmpresarial: string;
  [key: string]: any;
};

export type SesUserTableRow = {
  id: string | number;
  status: boolean;
  nome: string;
  cpf: string;
  celular: string;
  email: string;
  dataVinculacao: string;
  responsavelVinculacao: string;
  [key: string]: any;
};

export type SesBondTableRow = {
  id: string | number;
  status: boolean;
  nome: string;
  dataInicio: string;
  cargo: string;
  [key: string]: any;
};

const renderStatusDot = (value: unknown) => {
  const isActive = value === true || value === 'S';
  return <BolinhaTabelaStatus status={isActive ? 'S' : 'N'} />;
};

export const headersSES: CustomTableHeader<SesTableRow>[] = [
  { text: '', width: 1, key: '', renderable: false },
  { text: 'ID', width: 8, key: 'id', fieldType: 'number' },
  {
    text: 'Estabelecimento de Saúde',
    width: 30,
    key: 'nome',
  },
  { text: 'UF', width: 6, key: 'ufSigla', fieldType: 'select' },
  { text: 'CNES', width: 8, key: 'cnes' },
  {
    text: 'Razão Social',
    width: 47,
    key: 'nomeEmpresarial',
  },
];

export const headersSesUsuarios: CustomTableHeader<SesUserTableRow>[] = [
  { text: '', width: 1, key: '', renderable: false },
  { text: 'ID', width: 5, key: 'id', fieldType: 'number' },
  {
    text: 'Status',
    width: 4,
    key: 'status',
    renderCell: (value) => renderStatusDot(value),
    fieldType: 'checkbox',
    filterDefaultValue: 'false',
  },
  { text: 'Nome Completo', width: 25, key: 'nome' },
  { text: 'CPF', width: 10, key: 'cpf' },
  { text: 'Celular', width: 10, key: 'celular' },
  { text: 'Email', width: 15, key: 'email' },
  { text: 'Dt. Vinc.', width: 15, key: 'dataVinculacao' },
  { text: 'Resp. Vinc.', width: 15, key: 'responsavelVinculacao' },
];

export const headersSesVinculo: CustomTableHeader<SesBondTableRow>[] = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id', fieldType: 'number' },
  {
    text: 'Status',
    width: 15,
    key: 'status',
    renderCell: (value) => renderStatusDot(value),
    fieldType: 'checkbox',
    filterDefaultValue: 'false',
  },
  { text: 'Nome Completo', width: 25, key: 'nome' },
  { text: 'Dt. Início', width: 15, key: 'dataInicio' },
  { text: 'Cargo', width: 25, key: 'cargo' },
];

export const fieldObjectSES = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
